<template>
    <div>
        <CRUDCriteria :showReset="true" :showSearch="false" :showAdditionalActions="true">
            <template v-slot:criteriaRows>
                <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
                    <v-row class="ma-n4">
                        <v-col cols="1" class="pt-0 pb-0 tax-year-col" id="taxYearCol">
                          <CommonDropDowns
                            :isItTaxYear="true"
                            @change="dataFromCommonDropDowns"
                            :criteriaState="criteriaState"
                            class="tax-roll-criteria-tax-year-dropdown"
                            id="taxRollCriteriaTaxYearDropdown"
                        />
                        </v-col>
                        <v-col cols="1" class="pt-0 pb-0 tax-id-col" id="taxIdCol">
                          <v-text-field
                            ref="taxIdField"
                            class="input-text-size tax-roll-criteria-tax-id-input"
                            id="taxRollCriteriaTaxIdInput"
                            label="Tax ID"
                            type="number"
                            v-model.number="criteriaState.taxId"
                            @input="searchByTimeOut()"
                            @click="resetTaxYearAndBaseId"
                          />
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field class="input-text-size" label="PID"
                            v-model="criteriaState.propertyOrParcelId" @input="searchByTimeOut"
                            @blur="formatToPidWithDashes('propertyOrParcelId')"
                            @focus="formatToPidWith('propertyOrParcelId'), $event.target.select()"
                            v-uppercase=globalSettingItem.conEverythingToCaps
                            @click="resetTaxYearAndBaseId" />
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field class="input-text-size" label="Base ID"
                            v-model.number="criteriaState.baseId"
                            @input="searchByTimeOut" type="number" />
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field class="input-text-size" label="From Amt"
                            v-model.number="criteriaState.fromAmt"
                            @change="onFromAmtChange(); searchByCriteria();"
                            @input="searchByTimeOut" type="number" />
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field class="input-text-size" label="To Amt"
                            v-model.number="criteriaState.toAmt"
                            @input="searchByTimeOut" type="number" />
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                          <v-checkbox class="input-text-size" @change="searchByCriteria"
                             v-model="criteriaState.isItBaseTax" label="Base Tax" />
                        </v-col>
                        <v-col cols="3" class="pt-0 pb-0 mt-n6">
                            <CommonDropDowns :key="`mtgCode-${resetKey}`" :isItMtgCode=true @change="dataFromCommonDropDowns"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0 mt-n6">
                            <CommonDropDowns :key="`staCode-${resetKey}`" :isItstaCode=true @change="dataFromCommonDropDowns"/>
                        </v-col>
                        <v-col cols="3" class="pt-0 pb-0 mt-n6">
                            <v-text-field class="input-text-size" @click="resetTaxYearAndBaseId"
                             v-model="criteriaState.situsAddress"
                             label="Situs Address" @input="searchByTimeOut"
                             v-uppercase=globalSettingItem.conEverythingToCaps />
                        </v-col>
                        <v-col cols='2' class="pt-0 pb-0 mt-n6">
                            <ClarionDateControl class="input-text-size"
                             @input="penaltyCaclFunc" :isToggle="false"
                             :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
                             v-model="criteriaState.penaltyDateValue" label="Penalty Date" />
                        </v-col>
                        <v-col
                          cols="2"
                          class="pt-0 pb-0 mt-n6 tax-roll-criteria-unpaids-checkbox-col"
                          id="taxRollCriteriaUnpaidsCheckboxCol"
                        >
                          <v-checkbox
                            class="input-text-size tax-roll-criteria-unpaids-checkbox"
                            id="taxRollCriteriaUnpaidsCheckbox"
                            @change="searchByCriteria"
                            v-model="criteriaState.unpaids"
                            :label="`Unpaids Only`"
                          />
                        </v-col>
                    </v-row>
                </div>
                <v-expansion-panels class="mb-3">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="ma-n1">
                            <b class="input-text-size">Additional Search</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row class="row pt-1">
                                <v-col cols="2" class="pt-0 pb-0 mt-n5">
                                   <CommonDropDowns :key="`additions-${resetKey}`" :isItAdditions=true
                                   :taxAdditionValue="criteriaState.addition"
                                   @change="dataFromCommonDropDowns"/>
                                </v-col>
                                <v-col cols="1" class="pt-0 pb-0 mt-n5">
                                    <v-text-field class="input-text-size" label="Lot"
                                    v-model.number="criteriaState.lot"
                                    @input="searchByTimeOut"
                                    type="number" />
                                </v-col>
                                <v-col cols="1" class="pt-0 pb-0 mt-n5">
                                    <v-text-field class="input-text-size" label="Block"
                                    v-model="criteriaState.block"
                                    @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n5">
                                    <v-text-field class="input-text-size" label="Section"
                                    v-model="criteriaState.section"
                                    @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n5">
                                    <v-text-field class="input-text-size" label="Township"
                                    v-model="criteriaState.townShip"
                                    @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n5">
                                    <v-text-field class="input-text-size" label="Range"
                                    v-model="criteriaState.range"
                                    @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n5">
                                    <v-text-field class="input-text-size" label="Invoice Number"
                                    v-model="criteriaState.invoiceNumber"
                                    @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n6">
                                    <v-text-field class="input-text-size" label="Number"
                                    v-model.number="criteriaState.situsStreetNumber"
                                    @input="searchByTimeOut"
                                    type="number" />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n6">
                                    <v-text-field class="input-text-size" label="Direction"
                                    v-model="criteriaState.situsStreetDirection"
                                    @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0 mt-n6">
                                    <v-combobox :items="streetList"
                                    class="input-text-size" label="Street Name"
                                    v-model="criteriaState.situsStreetName"
                                    item-text="name"
                                    item-value="value"
                                    :return-object="false"
                                    :loading="isLoading"
                                    :search-input.sync="searchStreets"
                                    @change="searchByCriteria"
                                    />
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0 mt-n6">
                                    <v-text-field class="input-text-size" label="Street Type"
                                    v-model="criteriaState.situsStreetType" @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0 mt-n6">
                                    <v-text-field class="input-text-size" label="Town"
                                    v-model="criteriaState.situsTown" @input="searchByTimeOut"
                                    v-uppercase=globalSettingItem.conEverythingToCaps />
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </template>
            <template v-slot:additionalActions>
              <v-col cols="auto" class="pt-0 mt-n1 pr-6">
                <StatementsToggle />
              </v-col>
              <v-col v-if="canActOnTaxRecord" cols="auto" class="pt-0 mt-n1 pr-6">
                <PayNowSettings />
              </v-col>
              <!-- Pulled up no further than mt-n2: a v-select floats its label above the
                   control, and a bigger negative margin puts "Middle Section" into the criteria
                   row above it. -->
              <v-col cols="2" class="pt-0 mt-n2">
                <MiddleSectionSelect />
              </v-col>
              <!-- No Pick List button for the view-only persona, so no Pick List / Protest
                   dialog either - ProtestAndPickListTabs below goes with it. -->
              <v-col v-if="canActOnTaxRecord" cols="2" class="pt-0 tax-roll-criteria-pick-list-btn-col"
               id="taxRollCriteriaPickListBtnCol">
                <v-btn
                  class="input-text-size tax-roll-criteria-pick-list-btn white-space-pre-line"
                  id="taxRollCriteriaPickListBtn"
                  text
                  color="blue darken-1"
                  @click="handlePickList"
                >
                  <span>{{pickListProfileName}}</span>
                </v-btn>
              </v-col>
            </template>
        </CRUDCriteria>
        <ProtestAndPickListTabs v-if="canActOnTaxRecord" :baseCrudKey="baseCrudKeyPickList"
         @refetchTaxInquiryData="refetchTaxInquiryData" />
    </div>
</template>

<script>
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import '../../../../assets/style.css';
import { TaxViewOnlyMixin } from '../TaxInquiryUtils/taxViewOnly.mixin';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { toShortDate } from '../../../../util/shared/tmc-global';
import { pIdFormat } from '../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import CRUDCriteria from '../../../common/base/crud-2.0/CRUDCriteria.vue';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import {
  dedupeItemsByValue, mergeCodeWithName, penaltyCaclCrudListCommonFunc, taxInquiryCriteriaFilter,
} from '../../common-utils/CommonTaxFunctionalities';
import { SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';
import MiddleSectionSelect from '../Common/MiddleSectionSelect.vue';
import PayNowSettings from '../Common/PayNowSettings.vue';
import ProtestAndPickListTabs from '../Common/ProtestAndPickListTabs.vue';
import StatementsToggle from '../Common/StatementsToggle.vue';

export default {
  mixins: [GlobalToCaps, TaxViewOnlyMixin],
  data() {
    return {
      pickListProfileName: 'Pick List',
      baseCrudKeyPickList: 'ProtestAndPickListTabs',
      delayTimerId: null,
      workstation: getWorkstationNumber(),
      searchStreets: '',
      isLoading: false,
      resetKey: 0,
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
    feeListBasedInIds: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
    MiddleSectionSelect,
    PayNowSettings,
    ProtestAndPickListTabs,
    StatementsToggle,
    CommonDropDowns,
  },
  created() {
    this.criteriaState.penaltyDateValue = this.criteriaState.penaltyDateValue || toShortDate();
    this.getPickListProfileName();
  },
  mounted() {
    this.getPickListProfileName();
    window.addEventListener('keydown', this.onEscapeClear, true);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onEscapeClear, true);
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible', 'criteria', 'topDialog']),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapGetters('user', [
      'getSettings',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      pickListVisible: (state) => state.base.crud.isVisible.ProtestAndPickListTabs,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    streetList() {
      const baseCrudKey = 'taxStreetsTable';
      const itemData = this.items(baseCrudKey);
      // One item per street name: the table has a row per direction/type/town, and
      // a duplicated name renders the selection once per duplicate (TKT-000795).
      const updatedItems = mergeCodeWithName(itemData, 'streetName', 'streetName', true, true);
      return dedupeItemsByValue(updatedItems);
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setCriteria',
      'setItems',
      'setItem',
      'setPaginationItems',
      'setHighlightedId',
    ]),
    ...mapActions('shared/TaxStreets', ['loadTaxStreetsRecords']),
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        // Skip firing an expensive text search on 1-2 chars (avoids full-collection scans).
        const guardFields = ['situsAddress', 'situsStreetName', 'comOwnerAddress', 'inCareOf'];
        const tooShort = guardFields.some((f) => {
          const v = (this.criteriaState[f] || '').trim();
          return v.length > 0 && v.length < 3;
        });
        if (tooShort) return;
        this.setHighlightedId([this.baseCrudKey, '']);
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    resetTaxYearAndBaseId() {
      // When user returns to Tax ID field after using Browse by Base ID,
      // 1. Tax Year should auto-reset to current fiscal year
      // 2. Base ID should be cleared automatically
      if (!this.criteriaState.taxYear && this.criteriaState.baseId) {
        this.criteriaState.taxYear = Number(this.taxSettingItem.taxYear) || this.latestTaxYear || 0;
        this.criteriaState.baseId = null;
        this.searchByTimeOut();
      }
    },
    penaltyCaclFunc(val) {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
        const itemData = this.items(this.baseCrudKey);
        const itemFeeData = this.feeListBasedInIds;
        const returnData = penaltyCaclCrudListCommonFunc(
          val, itemData, this.taxSettingItem, itemFeeData,
        );
        this.setItems(this.baseCrudKey, returnData);
        this.$emit('onPenaltyDateChange');
      }, SEARCH_DEBOUNCE_TIMER);
    },
    handlePickList() {
      const pickListFilterItem = {
        taxYear: 0,
        statusCode: null,
        mtgCode: null,
        profileName: '',
      };
      this.setCriteria(['pickListCriteria', pickListFilterItem]);
      this.setItem(['pickListMakePaymentDate', { curPenaltyDate: this.criteriaState.penaltyDateValue }]);
      // this will make the pagination to default
      const paginationItem = {
        itemsperpage: this.getSettings.itemsperpage,
        serverItemsLength: this.getSettings.serverItemsLength,
        footerProps: this.getSettings.footerProps,
      };
      this.setPaginationItems(['pickListTable', paginationItem]);
      this.setPaginationItems(['ProtestTaxPaymentsList', paginationItem]);
      this.$emit('setDefaultSelectedItems');
      this.setIsVisible([this.baseCrudKeyPickList, true]);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    onFromAmtChange() {
      this.criteriaState.toAmt = this.criteriaState.fromAmt;
    },
    searchByCriteria() {
      const returnCriteria = taxInquiryCriteriaFilter(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList');
    },
    refetchTaxInquiryData() {
      this.$emit('loadCRUDList');
    },
    formatToPidWithDashes(val) {
      const criteriaVal = this.criteriaState[val] || '';
      // to check is the isDoPidEntry is true and also is it a taxid or PID
      if (!!this.taxSettingItem.isDoPidEntry && (criteriaVal).length > 7) {
        const formatPidPositions = this.taxSettingItem.pidValue || '';
        const formattedPid = pIdFormat(criteriaVal, formatPidPositions);
        this.criteriaState[val] = formattedPid;
      }
    },
    formatToPidWith(val) {
      const criteriaVal = this.criteriaState[val] || '';
      if (!!this.taxSettingItem.isDoPidEntry && (criteriaVal).length > 7) {
        let formatedPid = null;
        if (criteriaVal) formatedPid = criteriaVal.replace(/-/g, '');
        this.criteriaState[val] = formatedPid;
      }
    },
    async apiCallOnEnterText(searchName) {
      const checkSearchNameIsEmptyOrNot = searchName !== null ? searchName : '';
      const checkStreetEmptyOrNot = this.criteriaState && this.criteriaState.situsStreetName
        ? this.criteriaState.situsStreetName : null;
      const conditionOne = checkSearchNameIsEmptyOrNot === '' || checkStreetEmptyOrNot === '';
      if (conditionOne || checkSearchNameIsEmptyOrNot || checkStreetEmptyOrNot) {
        this.isLoading = true;
        clearTimeout(this.delayTimerId);
        this.delayTimerId = setTimeout(async () => {
          const criteriaList = {
            limit: 100,
            skip: 0,
            searchByEnteredtext: (checkSearchNameIsEmptyOrNot || checkStreetEmptyOrNot),
            sortBy: [{
              column: 'streetName',
              direction: 'asc',
            }],
          };
          await this.loadTaxStreetsRecords({ criteria: criteriaList, baseCrudKey: 'taxStreetsTable' });
          this.isLoading = false;
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
    onEscapeClear(event) {
      if (event.key !== 'Escape') return;
      // Any dialog open → CRUDDialog handleEscKey closes the top one; don't interfere
      if (this.topDialog) return;
      this.criteriaState = {
        ...this.criteriaState,
        taxId: null,
        propertyOrParcelId: null,
        baseId: null,
        fromAmt: null,
        toAmt: null,
        isItBaseTax: false,
        mtgCode: null,
        statusCode: null,
        situsAddress: null,
        penaltyDateValue: toShortDate(),
        unpaids: false,
        addition: null,
        lot: null,
        block: null,
        section: null,
        townShip: null,
        range: null,
        invoiceNumber: null,
        situsStreetNumber: null,
        situsStreetDirection: null,
        situsStreetName: null,
        situsStreetType: null,
        situsTown: null,
      };
      this.resetKey += 1;
      this.searchByCriteria();
      this.$nextTick(() => {
        this.$refs.taxIdField.focus();
      });
    },
    getPickListProfileName() {
      this.pickListProfileName = `Pick List \n ${localStorage.getItem('pick-list-profile-name') || ''}`;
    },
  },
  watch: {
    searchStreets(searchName) {
      this.apiCallOnEnterText(searchName);
    },
    pickListVisible() {
      this.getPickListProfileName();
    },
  },
};
</script>
